// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__WEocT","tableRow":"styles_tableRow__1BBPR","sorted":"styles_sorted__9w4hB"};